import { createFileRoute } from '@tanstack/react-router'

import { PrivacySection } from '@/features/organization/privacy-section'

export const Route = createFileRoute('/_app/organizacao/privacidade')({
  component: PrivacidadeTab,
})

function PrivacidadeTab() {
  return <PrivacySection />
}
